<template>
  <div class="flex items-center">
    <span class="text-xl mr-2">{{ title }}</span>
    <span
      v-if="newBadge"
      class="flex items-center h-4 rounded-full font-heavy
      bg-orange uppercase text-white px-2 text-xxs pt-1">
      {{ $t('new') }}
    </span>
  </div>
</template>

<script>
export default {
  name: 'BaseListHeader',

  props: {
    title: {
      type: String,
      required: true,
    },
    newBadge: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
